import React, {useEffect, useState} from "react";
import items from './SliderTopTen.json';
import itemsPeliculas from './SliderTopTenPeliculas.json';
import Slider from 'react-slick';
import SlideTopTen from './SlideTopTen';

const SliderTopTen = () => {

  const [menuItem, setMenuItem] = useState(items);
  const [menuItemP, setMenuItemP] = useState(itemsPeliculas);

    var settings = {
        className: "center",
        dots: false,
        infinite: false,
        autoplaySpeed: 8000,
        speed: 2000,
        centerPadding: '160px',
        slidesToShow: 4,
        slidesToScroll: 3,
        focusOnSelect: true,
        initialSlide: 0,
        arrows: false,
        responsive: [
        {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              centerMode: true,
              infinite: false,
              slidesToScroll: 1,
              initialSlide: 1,
              centerPadding: '100px',
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              infinite: false,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '60px',
              dots: false
            }
          }
        ]
      };
    useEffect(() => {
      const tabs = document.querySelectorAll('[data-role="tab"]'),
      tabContents = document.querySelectorAll(".tab-panel");
      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const target = document.querySelector(tab.dataset.target);
          tabContents.forEach((tc) => {
            tc.classList.remove("is-active");
          });
          target.classList.add("is-active");
          tabs.forEach((t) => {
            t.classList.remove("is-active");
          });
          tab.classList.add("is-active");
        });
      });
    }, [])

    return (
        <section className="SliderTopTen">

          <div className="container">
          
            <div className="tabs-wrapper">
              <ul className="nav-tabs" role="tablist">
                <li className="nav-item tab is-active" data-role="tab" data-target="#tab-peliculas">Top 10 <span>Películas</span><i>🍿</i></li>
                <li className="nav-item tab series" data-role="tab" data-target="#tab-series">Top 10 <span>Series</span><i>🔥</i></li>
              </ul>

              <div className="tab-content">

                <div className="tab-panel is-active" id="tab-peliculas" role="tabpanel">
                    <Slider {...settings}>
                    {
                      menuItemP.map(({ id, posicion, link, screenshot}) => {
                          return <SlideTopTen id={id} posicion={posicion} link={link} screenshot={screenshot} />
                      })
                    }
                    </Slider>
                </div>

                <div className="tab-panel" id="tab-series" role="tabpanel">
                  <Slider {...settings}>
                    {
                      menuItem.map(({ id, posicion, link, screenshot}) => {
                          return <SlideTopTen id={id} posicion={posicion} link={link} screenshot={screenshot} />
                      })
                    }
                    </Slider>
                </div>

              </div>

            </div>
          </div>
        </section>


 
      );
    }

    export default SliderTopTen